import React, { Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'react-bootstrap/Button'
import { faCheckCircle, faMinus, faPlus, faTh } from '@fortawesome/free-solid-svg-icons';
import { ImagenesRutas } from "../../../request/RutasConfig";

export const tarjetaArticulo = (orden, cargando, filtro, sucursalId, auditarProducto, accionBotonMenos, accionBotonMas, accionChange, onClickLotes, sucursalAplicaLotes, preparar = false, validarArticuloDespacho = false, key = 0) => {
    let productos = orden.productos;

    if (Array.isArray(productos)) {
        if (preparar) {
            if (filtro === "categoria") {
                let categorias = [];
                let productosCategorizados = [];

                productos.forEach(producto => {
                    if (!categorias.includes(producto.categoria)) {
                        categorias.push(producto.categoria);
                    }
                });

                categorias.forEach(categoria => {
                    let categoriaProductos = [];
                    productos.forEach(producto => {
                        if (producto.categoria === categoria) {
                            categoriaProductos.push(producto);
                        }
                    })

                    productosCategorizados.push({ categoria, productos: categoriaProductos });
                });

                return (
                    <>
                        {
                            productosCategorizados.map((categoria, i) => {
                                return (
                                    <Fragment key={i}>
                                        <p className="mt-4">{categoria.categoria}</p>
                                        {
                                            categoria.productos.filter(producto => producto.sucursal == sucursalId).map((x, index) => {
                                                x.Estatus_id = orden.Estatus_id;
                                                return tarjetaArticulo(x, cargando, filtro, sucursalId, auditarProducto, accionBotonMenos, accionBotonMas, accionChange, onClickLotes, sucursalAplicaLotes, preparar, validarArticuloDespacho, index);
                                            })
                                        }
                                    </Fragment>
                                )


                            })
                        }
                    </>
                )
            }

            if (filtro === "ubicacion") {
                return (
                    <>
                        {
                            productos.length > 0 && productos.filter(producto => producto.sucursal == sucursalId).map((producto, index) => {
                                producto.Estatus_id = orden.Estatus_id;
                                return tarjetaArticulo(producto, cargando, filtro, sucursalId, auditarProducto, accionBotonMenos, accionBotonMas, accionChange, onClickLotes, sucursalAplicaLotes, preparar, index);
                            })
                        }
                    </>
                )
            }
        } else {
            return (
                <>
                    {
                        productos.length > 0 && productos.filter(producto => producto.sucursal == sucursalId).map((producto, index) => {
                            producto.Estatus_id = orden.Estatus_id;
                            return tarjetaArticulo(producto, cargando, filtro, sucursalId, auditarProducto, accionBotonMenos, accionBotonMas, accionChange, onClickLotes, sucursalAplicaLotes, preparar, validarArticuloDespacho, index);
                        })
                    }
                </>
            )
        }
    } else {
        let producto = orden;

        if (producto.sucursal != sucursalId) {
            return null;
        }

        let unidadesSuma = 1;
        let unidadesResta = 1;
        return (
            <div className="picking-orden-item" key={key}>
                <div className="row">
                    <div className="col etiqueta">
                        <p className="codigo">{producto.codigo_principal ? producto.codigo_principal : producto.id} {producto.nombre}</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-auto" style={{ alignSelf: "center" }}>
                        <img className="item-picking-image" src={producto.imagen && producto.imagen.length > 0 && producto.imagen !== "https://dummyimage.com/100x100" ? producto.imagen : ImagenesRutas.ArtDefault} />
                    </div>
                    <div className="col">
                        <div className="row">
                            {
                                preparar ?
                                    <div className="col">
                                        <p className="cant-picking">Existencia: {producto.existencia}</p>
                                    </div>
                                    :
                                    ""
                            }
                            <div className="col">
                                <p className="cant-picking">Solicitado: {producto.solicitado}</p>
                            </div>
                            <div className="col">
                                <p className="cant-picking">Auditado: {producto.auditado}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col auto">
                        {
                            preparar && orden.estadoAuditoria == "PE" && orden.editado || preparar && orden.estadoAuditoria == "PE" && producto.seleccionPreparar == 0 ?
                                <Button disabled={cargando} onClick={() => { auditarProducto(sucursalId, producto) }} variant="primary">{cargando ? <><i className="fa fa-refresh fa-spin" style={{ marginRight: "5px" }} /> Cargando...</> : "Auditar"}</Button>
                                :
                                (preparar || orden.estadoAuditoria == "AP") && <p className="estado-auditado todo" className={"estado-auditado " + (producto.todo ? "todo" : "")}>{orden.estadoAuditoria == "AP" ? <><FontAwesomeIcon icon={faCheckCircle} /> Auditado</> : ""}</p>
                        }
                        {
                            preparar && sucursalAplicaLotes && orden.Estatus_id === 'O' && producto.aplica_lote ?
                                <Button onClick={() => onClickLotes(producto)} disabled={producto.auditado === 0} variant="primary" className="ml-2" title="Aplica Lote"><FontAwesomeIcon icon={faTh} /></Button>
                                : null
                        }
                    </div>
                    {
                        preparar ?
                            <div className="col-auto col-xs-12 text-right">
                                <div className="quantity2">
                                    <button disabled={((producto.seleccionPreprar - unidadesResta) < 0)} className="btn" onClick={() => accionBotonMenos(producto, unidadesResta, "restar")}><FontAwesomeIcon icon={faMinus} /></button>
                                    <input type="number" value={producto.seleccionPreparar} onChange={(e) => { accionChange(producto, e) }} disabled={validarArticuloDespacho && !producto.Detalle_Articulo_Validado} />
                                    <button disabled={((producto.seleccionPreprar + unidadesSuma) > producto.existencia)} className="btn" onClick={() => accionBotonMas(producto, unidadesSuma, "sumar")}><FontAwesomeIcon icon={faPlus} /></button>
                                </div>
                            </div>
                            : null
                    }
                </div>
                {
                    filtro === "ubicacion" &&
                    <div className="row mt-2">
                        <div className="col etiqueta">
                            <p className="nombre">{`${producto.posicionA1}-${producto.posicionA2}-${producto.posicionA3}`}</p>
                        </div>
                    </div>
                }
            </div>
        )
    }
};